module.exports = __webpack_public_path__ + "static/img/midground.da96102.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/corridor/midground.svg
// module id = 68
// module chunks = 2